<div class="users">
  <mat-card>
    <mat-card-content>
      <div class="mat-card-content-label" fxLayoutAlign="space-between center" fxLayout="row" fxLayoutGap="0px" fxLayoutGap.lt-sm="15px" fxLayout.lt-sm="column">
        <label>Your renders</label>
      </div>
      <mat-card [ngClass.lt-sm]="{'mat-card-inline-sm': true}">
        <mat-card-content fxLayoutAlign="start center" fxLayout="column">
          <div class="filter w-100" fxFlex="100" fxLayoutAlign="center center" fxLayout="row" fxLayoutGap="15px" fxLayout.lt-sm="column">
            <mat-form-field class="accent">
              <mat-label>Search renders</mat-label>
              <input matInput type="text"
                [(ngModel)]="filter"
                (keyup.enter)="loadRenderedOutputs()"
                (keyup.esc)="filter=''; loadRenderedOutputs()"
                name="searchTerm"
                placeholder="Search Name">
              <button mat-button *ngIf="filter" matSuffix mat-icon-button aria-label="Clear" (click)="filter=''; loadRenderedOutputs()">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
            <div fxLayout="row" fxLayoutGap="10px">
              <button mat-icon-button [matTooltip]="isProductionOnly ? 'Show all!' : 'Live only!'" [color]="isProductionOnly ? 'accent' : 'basic'" (click)="toggleIsProductionOnly()">
                <mat-icon>verified</mat-icon>
              </button>
              <button type="submit" mat-flat-button color="primary" (click)="loadRenderedOutputs()" matTooltip="Search" [class.button-spinner]="loading" [disabled]="loading">
                <mat-icon>search</mat-icon> Search
              </button>
            </div>
          </div>
          <div class="m-b-20 w-100" fxFlex="100">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
              <small class="text-info"><i>filter:</i></small>
              <mat-chip-list #optionChipList>
                <mat-chip *ngIf="style" color="accent">
                  <span>Style</span>
                  <button matChipRemove (click)="clearFilter(StyleParamName)">
                    <mat-icon color="primary" matTooltip="Clear filter">clear</mat-icon>
                  </button>
                </mat-chip>
                <mat-chip *ngIf="config" color="accent">
                  <span>Config</span>
                  <button matChipRemove (click)="clearFilter(ConfigParamName)">
                    <mat-icon color="primary" matTooltip="Clear filter">clear</mat-icon>
                  </button>
                </mat-chip>
                <mat-chip *ngIf="home" color="accent">
                  <span>Home</span>
                  <button matChipRemove (click)="clearFilter(HomeParamName)">
                    <mat-icon color="primary" matTooltip="Clear filter">clear</mat-icon>
                  </button>
                </mat-chip>
                <mat-chip *ngIf="filter" color="accent">
                  <span>Search {{ filter }}</span>
                  <button matChipRemove (click)="clearFilter(FilterParamName)">
                    <mat-icon color="primary" matTooltip="Clear filter">clear</mat-icon>
                  </button>
                </mat-chip>
              </mat-chip-list>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
      <div fxLayout="row wrap">
        <div class="md-card-wrapper" *ngFor="let item of dataSource.data">
          <mat-card class="contrast browse-card">
            <ng-container [ngSwitch]="item?.productName">
              <img *ngSwitchCase="productNames.Facade" class="card-link" style="height: 225px" (click)="view(item)" mat-card-image src="/assets/images/background/user-info-generic.jpg" [lazyLoad]="getFacadeImage(item?.artifactId)" matTooltip="situFACADE">
              <img *ngSwitchCase="productNames.Panorama" class="card-link" (click)="view(item)" mat-card-image src="/assets/images/background/user-info-generic.jpg" [lazyLoad]="getPanoImage(item?.artifactId)" matTooltip="situVIEW">
              <img *ngSwitchCase="productNames.RayTraced" class="card-link" (click)="view(item)" mat-card-image src="/assets/images/background/user-info-generic.jpg" [lazyLoad]="getPanoImage(item?.artifactId)" matTooltip="situVIEW">
              <img *ngSwitchCase="productNames.RayTracedPlus" class="card-link" (click)="view(item)" mat-card-image src="/assets/images/background/user-info-generic.jpg" [lazyLoad]="getPanoImage(item?.artifactId)" matTooltip="situVIEW">
              <img *ngSwitchCase="productNames.Render" class="card-link" (click)="view(item)" mat-card-image src="/assets/images/background/user-info-generic.jpg" [lazyLoad]="getPanoImage(item?.artifactId)" matTooltip="situRENDER">
              <img *ngSwitchDefault class="blurred-image card-link" (click)="view(item)" mat-card-image src="/assets/images/background/user-info-generic.jpg">
            </ng-container>
            <mat-card-content class="browse-card-content" fxLayoutAlign="start center" fxLayout="row" fxLayout.lt-sm="column">
              <div fxFlex="100" fxLayoutAlign="start center" fxLayout="row" fxLayout.lt-sm="column">
                <div class="w-100" fxLayout="row" fxFlex="100">
                  <div fxLayout="column" fxLayoutGap="2px" fxFlex="80">
                    <ng-container *ngIf="item?.homeConfig?.options && item?.homeConfig?.options.length > 0">
                      <div fxLayoutAlign="start start" fxLayout="row" fxLayoutGap="5px">
                        <div class="font-14">options</div>
                        <div>></div>
                      </div>
                      <small class="no-spill" [innerHtml]="item?.homeConfig?.options.join(', ') | highlight: filter"></small>
                    </ng-container>
                    <ng-container *ngIf="item?.styleConfigTemplate?.name">
                      <div fxLayoutAlign="start start" fxLayout="row" fxLayoutGap="5px">
                        <div class="font-14">style</div>
                        <div>></div>
                      </div>
                      <small class="no-spill" [innerHtml]="item.styleConfigTemplate.name | highlight: filter"></small>
                    </ng-container>
                  </div>
                  <div fxFlex="20">
                    <ng-container [ngSwitch]="item?.productName">
                      <span *ngSwitchCase="productNames.Facade" fxLayout="column" fxLayoutAlign="end end">
                        <mat-icon color="accent" matTooltip="2048x1536" *ngIf="item?.callerReferenceKey?.endsWith('default')">2k</mat-icon>
                        <mat-icon color="accent" matTooltip="4096x3072" *ngIf="item?.callerReferenceKey?.endsWith('4096x3072')">4k</mat-icon>
                        <mat-icon color="accent" matTooltip="8192x6144" *ngIf="item?.callerReferenceKey?.endsWith('8192x6144')">8k</mat-icon>
                        <mat-icon color="accent" matTooltip="16384x12288" *ngIf="item?.callerReferenceKey?.endsWith('16384x12288')">8k_plus</mat-icon>
                        <mat-icon [style.color]="getProductColour(item?.productName)" matTooltip="situFACADE">image</mat-icon>
                      </span>
                      <span *ngSwitchCase="productNames.RayTraced" fxLayout="column" fxLayoutAlign="end end">
                        <mat-icon color="accent" matTooltip="ray traced">4k_plus</mat-icon>
                        <mat-icon [style.color]="getProductColour(item?.productName)" matTooltip="situVIEW">panorama</mat-icon>
                      </span>
                      <span *ngSwitchCase="productNames.RayTracedPlus" fxLayout="column" fxLayoutAlign="end end">
                        <mat-icon color="accent" matTooltip="ray traced plus">8k</mat-icon>
                        <mat-icon [style.color]="getProductColour(item?.productName)" matTooltip="situVIEW">panorama</mat-icon>
                      </span>
                      <span *ngSwitchCase="productNames.Plan" fxLayout="column" fxLayoutAlign="end end">
                        <mat-icon [style.color]="getProductColour(item?.productName)" matTooltip="situPLAN">foundation</mat-icon>
                      </span>
                      <span *ngSwitchCase="productNames.Render" fxLayout="column" fxLayoutAlign="end end">
                        <mat-icon [style.color]="getProductColour(item?.productName)" matTooltip="situRENDER">photo_camera</mat-icon>
                      </span>
                      <span *ngSwitchDefault fxLayout="column" fxLayoutAlign="end end">
                        <mat-icon color="accent" matTooltip="standard">4k</mat-icon>
                        <mat-icon [style.color]="getProductColour(item?.productName)" matTooltip="situVIEW">panorama</mat-icon>
                      </span>
                    </ng-container>
                    
                  </div>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
          <span class="header" fxLayout="row" fxLayoutAlign="space-between center">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="2px">
              <strong [class.home-text]="isDarkMode" [innerHtml]="item?.homeConfig?.home | highlight: filter"></strong>
              <mat-icon *ngIf="item?.isProduction" matTooltip="Is Live!" color="accent">verified</mat-icon>
            </div>
            <div fxLayout="row" fxLayoutAlign="end center">
              <span fxLayout="row" fxLayoutAlign="end center">
                <small [innerHtml]="item?.homeConfig?.masterFile | highlight: filter"></small>
                <mat-icon *ngIf="isSituUser" class="text-danger link" (click)="cancelRenderedOutput(item); $event.stopPropagation();">clear</mat-icon>
              </span>
            </div>
          </span>
          <span class="footer" [class.facade]="item?.productName === productNames.Facade" fxLayout="row" fxLayoutAlign="space-between center">
            <small style="color: black; font-weight: bold;">{{ item.dateCreated | date:'short' }}</small>
            <div>
              <mat-icon class="link" color="accent" matTooltip="Open in new Window" (click)="view(item, true); $event.stopPropagation();">open_in_new</mat-icon>
              <source-artifacts-menu class="card-icon"
                [isSituUser]="isSituUser"
                [isAdmin]="isAdmin"
                [isDarkMode]="isDarkMode"
                [sourceArtifacts]="item?.sourceArtifacts">
              </source-artifacts-menu>
            </div>
          </span>
        </div>
      </div>
      <mat-card [ngClass.lt-sm]="{'mat-card-inline-sm': true}">
        <mat-paginator [length]="viewControls.totalItems"
          [pageSize]="viewControls.pageSize"
          [pageIndex]="viewControls.pageIndex"
          [pageSizeOptions]="viewControls.pageSizeOptions"
          (page)="onPageChange($event)">
        </mat-paginator>
      </mat-card>
    </mat-card-content>
  </mat-card>
</div>